app.controller("StudentNewSubjectDetailsController", [
    "$scope", "$q", "StSubject", "subject", "$uibModalInstance",
    function ($scope, $q, StSubject, subject, $uibModalInstance) {
        $scope.subject = subject;
        $scope.grades = subject.details;

        $scope.gradeColor = function (grade) {
            if (grade.grade && grade.grade.absolute && grade.minValue > grade.grade.absolute) return 'red';
            if (grade.replaced) return 'gray';
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);